// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-height0{height:0px}
.ui-width0{width:0px}
.p-t-0{padding-top:0px}
.p-r-0{padding-right:0px}
.p-l-0{padding-left:0px}
.p-b-0{padding-bottom:0px}
.m-t-0{margin-top:0px}
.m-r-0{margin-right:0px}
.m-l-0{margin-left:0px}
.m-b-0{margin-bottom:0px}
.ui-height5{height:5px}
.ui-width5{width:5px}
.p-t-5{padding-top:5px}
.p-r-5{padding-right:5px}
.p-l-5{padding-left:5px}
.p-b-5{padding-bottom:5px}
.m-t-5{margin-top:5px}
.m-r-5{margin-right:5px}
.m-l-5{margin-left:5px}
.m-b-5{margin-bottom:5px}
.ui-height10{height:10px}
.ui-width10{width:10px}
.p-t-10{padding-top:10px}
.p-r-10{padding-right:10px}
.p-l-10{padding-left:10px}
.p-b-10{padding-bottom:10px}
.m-t-10{margin-top:10px}
.m-r-10{margin-right:10px}
.m-l-10{margin-left:10px}
.m-b-10{margin-bottom:10px}
.ui-height15{height:15px}
.ui-width15{width:15px}
.p-t-15{padding-top:15px}
.p-r-15{padding-right:15px}
.p-l-15{padding-left:15px}
.p-b-15{padding-bottom:15px}
.m-t-15{margin-top:15px}
.m-r-15{margin-right:15px}
.m-l-15{margin-left:15px}
.m-b-15{margin-bottom:15px}
.ui-height20{height:20px}
.ui-width20{width:20px}
.p-t-20{padding-top:20px}
.p-r-20{padding-right:20px}
.p-l-20{padding-left:20px}
.p-b-20{padding-bottom:20px}
.m-t-20{margin-top:20px}
.m-r-20{margin-right:20px}
.m-l-20{margin-left:20px}
.m-b-20{margin-bottom:20px}
.ui-height25{height:25px}
.ui-width25{width:25px}
.p-t-25{padding-top:25px}
.p-r-25{padding-right:25px}
.p-l-25{padding-left:25px}
.p-b-25{padding-bottom:25px}
.m-t-25{margin-top:25px}
.m-r-25{margin-right:25px}
.m-l-25{margin-left:25px}
.m-b-25{margin-bottom:25px}
.ui-height30{height:30px}
.ui-width30{width:30px}
.p-t-30{padding-top:30px}
.p-r-30{padding-right:30px}
.p-l-30{padding-left:30px}
.p-b-30{padding-bottom:30px}
.m-t-30{margin-top:30px}
.m-r-30{margin-right:30px}
.m-l-30{margin-left:30px}
.m-b-30{margin-bottom:30px}
.ui-height35{height:35px}
.ui-width35{width:35px}
.p-t-35{padding-top:35px}
.p-r-35{padding-right:35px}
.p-l-35{padding-left:35px}
.p-b-35{padding-bottom:35px}
.m-t-35{margin-top:35px}
.m-r-35{margin-right:35px}
.m-l-35{margin-left:35px}
.m-b-35{margin-bottom:35px}
.ui-height40{height:40px}
.ui-width40{width:40px}
.p-t-40{padding-top:40px}
.p-r-40{padding-right:40px}
.p-l-40{padding-left:40px}
.p-b-40{padding-bottom:40px}
.m-t-40{margin-top:40px}
.m-r-40{margin-right:40px}
.m-l-40{margin-left:40px}
.m-b-40{margin-bottom:40px}
.ui-height45{height:45px}
.ui-width45{width:45px}
.p-t-45{padding-top:45px}
.p-r-45{padding-right:45px}
.p-l-45{padding-left:45px}
.p-b-45{padding-bottom:45px}
.m-t-45{margin-top:45px}
.m-r-45{margin-right:45px}
.m-l-45{margin-left:45px}
.m-b-45{margin-bottom:45px}
.ui-height50{height:50px}
.ui-width50{width:50px}
.p-t-50{padding-top:50px}
.p-r-50{padding-right:50px}
.p-l-50{padding-left:50px}
.p-b-50{padding-bottom:50px}
.m-t-50{margin-top:50px}
.m-r-50{margin-right:50px}
.m-l-50{margin-left:50px}
.m-b-50{margin-bottom:50px}
.ui-height55{height:55px}
.ui-width55{width:55px}
.p-t-55{padding-top:55px}
.p-r-55{padding-right:55px}
.p-l-55{padding-left:55px}
.p-b-55{padding-bottom:55px}
.m-t-55{margin-top:55px}
.m-r-55{margin-right:55px}
.m-l-55{margin-left:55px}
.m-b-55{margin-bottom:55px}
.ui-height60{height:60px}
.ui-width60{width:60px}
.p-t-60{padding-top:60px}
.p-r-60{padding-right:60px}
.p-l-60{padding-left:60px}
.p-b-60{padding-bottom:60px}
.m-t-60{margin-top:60px}
.m-r-60{margin-right:60px}
.m-l-60{margin-left:60px}
.m-b-60{margin-bottom:60px}
.ui-height65{height:65px}
.ui-width65{width:65px}
.p-t-65{padding-top:65px}
.p-r-65{padding-right:65px}
.p-l-65{padding-left:65px}
.p-b-65{padding-bottom:65px}
.m-t-65{margin-top:65px}
.m-r-65{margin-right:65px}
.m-l-65{margin-left:65px}
.m-b-65{margin-bottom:65px}
.ui-height70{height:70px}
.ui-width70{width:70px}
.p-t-70{padding-top:70px}
.p-r-70{padding-right:70px}
.p-l-70{padding-left:70px}
.p-b-70{padding-bottom:70px}
.m-t-70{margin-top:70px}
.m-r-70{margin-right:70px}
.m-l-70{margin-left:70px}
.m-b-70{margin-bottom:70px}
.ui-height75{height:75px}
.ui-width75{width:75px}
.p-t-75{padding-top:75px}
.p-r-75{padding-right:75px}
.p-l-75{padding-left:75px}
.p-b-75{padding-bottom:75px}
.m-t-75{margin-top:75px}
.m-r-75{margin-right:75px}
.m-l-75{margin-left:75px}
.m-b-75{margin-bottom:75px}
.ui-height80{height:80px}
.ui-width80{width:80px}
.p-t-80{padding-top:80px}
.p-r-80{padding-right:80px}
.p-l-80{padding-left:80px}
.p-b-80{padding-bottom:80px}
.m-t-80{margin-top:80px}
.m-r-80{margin-right:80px}
.m-l-80{margin-left:80px}
.m-b-80{margin-bottom:80px}
.ui-height85{height:85px}
.ui-width85{width:85px}
.p-t-85{padding-top:85px}
.p-r-85{padding-right:85px}
.p-l-85{padding-left:85px}
.p-b-85{padding-bottom:85px}
.m-t-85{margin-top:85px}
.m-r-85{margin-right:85px}
.m-l-85{margin-left:85px}
.m-b-85{margin-bottom:85px}
.ui-height90{height:90px}
.ui-width90{width:90px}
.p-t-90{padding-top:90px}
.p-r-90{padding-right:90px}
.p-l-90{padding-left:90px}
.p-b-90{padding-bottom:90px}
.m-t-90{margin-top:90px}
.m-r-90{margin-right:90px}
.m-l-90{margin-left:90px}
.m-b-90{margin-bottom:90px}
.ui-height95{height:95px}
.ui-width95{width:95px}
.p-t-95{padding-top:95px}
.p-r-95{padding-right:95px}
.p-l-95{padding-left:95px}
.p-b-95{padding-bottom:95px}
.m-t-95{margin-top:95px}
.m-r-95{margin-right:95px}
.m-l-95{margin-left:95px}
.m-b-95{margin-bottom:95px}
.ui-height100{height:100px}
.ui-width100{width:100px}
.p-t-100{padding-top:100px}
.p-r-100{padding-right:100px}
.p-l-100{padding-left:100px}
.p-b-100{padding-bottom:100px}
.m-t-100{margin-top:100px}
.m-r-100{margin-right:100px}
.m-l-100{margin-left:100px}
.m-b-100{margin-bottom:100px}
.ui-height105{height:105px}
.ui-width105{width:105px}
.p-t-105{padding-top:105px}
.p-r-105{padding-right:105px}
.p-l-105{padding-left:105px}
.p-b-105{padding-bottom:105px}
.m-t-105{margin-top:105px}
.m-r-105{margin-right:105px}
.m-l-105{margin-left:105px}
.m-b-105{margin-bottom:105px}
.ui-height110{height:110px}
.ui-width110{width:110px}
.p-t-110{padding-top:110px}
.p-r-110{padding-right:110px}
.p-l-110{padding-left:110px}
.p-b-110{padding-bottom:110px}
.m-t-110{margin-top:110px}
.m-r-110{margin-right:110px}
.m-l-110{margin-left:110px}
.m-b-110{margin-bottom:110px}
.ui-height115{height:115px}
.ui-width115{width:115px}
.p-t-115{padding-top:115px}
.p-r-115{padding-right:115px}
.p-l-115{padding-left:115px}
.p-b-115{padding-bottom:115px}
.m-t-115{margin-top:115px}
.m-r-115{margin-right:115px}
.m-l-115{margin-left:115px}
.m-b-115{margin-bottom:115px}
.ui-height120{height:120px}
.ui-width120{width:120px}
.p-t-120{padding-top:120px}
.p-r-120{padding-right:120px}
.p-l-120{padding-left:120px}
.p-b-120{padding-bottom:120px}
.m-t-120{margin-top:120px}
.m-r-120{margin-right:120px}
.m-l-120{margin-left:120px}
.m-b-120{margin-bottom:120px}
.ui-height125{height:125px}
.ui-width125{width:125px}
.p-t-125{padding-top:125px}
.p-r-125{padding-right:125px}
.p-l-125{padding-left:125px}
.p-b-125{padding-bottom:125px}
.m-t-125{margin-top:125px}
.m-r-125{margin-right:125px}
.m-l-125{margin-left:125px}
.m-b-125{margin-bottom:125px}
.wtrZI{text-align:left;font-family:Inter,sans-serif;font-weight:normal;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}
.wtrZI:hover{background-color:#20a6fc;color:#fff}
.wtrZI:active{background-color:#1e01ff}
.N7zMF{background-color:#1f65b1}
.c7JF9{width:100%;background-color:#f7f9fa;-webkit-box-shadow:0 0 6px #d3d3d3;box-shadow:0 0 6px #d3d3d3;margin:10px 0 20px;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}
@media(max-width: 767px){.Wto4W{margin-bottom:10px}}
.L_6hZ{background-color:#fff;border-color:#1f65b1;color:#fff;-webkit-box-shadow:none;box-shadow:none;border-radius:5px;display:inline-block}
.L_6hZ:hover,.L_6hZ:active{background-color:#0b4f8d;border-color:#0b4f8d;color:#fff}
.L_6hZ:active{-webkit-box-shadow:#1f65b1 0 0 0 .1rem;box-shadow:#1f65b1 0 0 0 .1rem}
.L_6hZ:focus,.L_6hZ:active:focus{-webkit-box-shadow:none;box-shadow:none}
.ZdjMH{background:#9ca0ad !important}
.VBwg2{background:#fff !important}
.Q6DyM{display:inline-block;width:20%;vertical-align:top;margin:0 auto auto}
.dvnvw{font-size:30px;margin-left:auto;margin-right:auto;color:#1f65b1;padding-top:5px;cursor:pointer}
.CZPGA{background-color:#1f65b1;border:1px solid #2065b2;border-radius:5px;color:#fff;font-family:Inter,sans-serif;font-size:18px;font-weight:bolder;line-height:19px;text-align:center;cursor:pointer;padding:13px 30px}
.CZPGA:hover,.CZPGA:active{background-color:#0b4f8d;border-color:#0b4f8d;color:#fff}
.HMH_N{background:#fff;height:100%;font-family:"Inter",sans-serif}
@media(max-width: 768px){.HMH_N{padding:20px;overflow-y:auto}}
.hM4MU{font-weight:700;font-size:42px;color:#0f172a;letter-spacing:-0.2px;line-height:125%;font-size:42px}
@media(max-width: 768px){.hM4MU{font-size:32px}}
.vUgsn{color:#0078d4;text-decoration:none;font-size:16px;font-weight:500}
.vUgsn:hover{text-decoration:underline;color:rgb(0,91.1320754717,161)}
.wovLb{color:hsl(215,20.2247191011%,60.0980392157%);font-weight:400;font-size:16px}
.ppx3v{color:#0078d4;text-decoration:none;font-weight:600}
.ppx3v:hover{text-decoration:underline;color:rgb(0,91.1320754717,161)}
.DziyJ{background-color:#fff4e5;border:3px solid #ea580c;border-radius:8px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:8px;padding:20px;text-align:left;width:100%}
.aFFY4{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px}
.ZAyJW{color:#ea580c;-ms-flex-negative:0;flex-shrink:0;font-size:28px;line-height:1.2;margin-top:2px}
.ep3pR{color:#222;font-family:Roboto,sans-serif,sans-serif;font-size:24px;font-weight:700;line-height:1.3;margin:0}
.CbaBT{color:#222;font-family:Roboto,sans-serif,sans-serif;font-size:16px;font-weight:600;line-height:26px;margin:12px 0 16px}
.Zoqu6{color:#222;font-family:Roboto,sans-serif,sans-serif;font-size:16px;font-weight:600;line-height:26px;margin-bottom:20px}
._ljOT{color:#16a34a;font-size:16px;font-weight:500;margin-top:10px;padding:12px;background-color:#ecfdf5;border:1px solid #bbf7d0;border-radius:8px;font-family:"Inter",sans-serif}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownItem": `wtrZI`,
	"dropdownItemActive": `N7zMF`,
	"dropdownMenu": `c7JF9`,
	"colMargin": `Wto4W`,
	"button": `L_6hZ`,
	"checkSome": `ZdjMH`,
	"noCheck": `VBwg2`,
	"inlineDots": `Q6DyM`,
	"dotIcon": `dvnvw`,
	"whiteButton": `CZPGA`,
	"rightPanel": `HMH_N`,
	"title": `hM4MU`,
	"forgotPasswordLink": `vUgsn`,
	"signupText": `wovLb`,
	"signupLink": `ppx3v`,
	"itLoginCallout": `DziyJ`,
	"itLoginCalloutHeading": `aFFY4`,
	"itLoginCalloutIcon": `ZAyJW`,
	"itLoginCalloutHeadline": `ep3pR`,
	"itLoginCalloutBody": `CbaBT`,
	"itLoginRedirectBody": `Zoqu6`,
	"successMessage": `_ljOT`
};
module.exports = ___CSS_LOADER_EXPORT___;
